import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=1a8262de&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a8262de')) {
      api.createRecord('1a8262de', component.options)
    } else {
      api.reload('1a8262de', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=1a8262de&", function () {
      api.rerender('1a8262de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xx73rc6ZHze/JS/comp/IncreaseNumber.vue"
export default component.exports